import { Roboto } from 'next/font/google';
import LocalFont from 'next/font/local';

const gothamFont = LocalFont({
  src: [
    {
      path: '../../public/next/fonts/gotham/Gotham-Bold.woff2',
      weight: '700',
      style: 'normal',
    },
    {
      path: '../../public/next/fonts/gotham/Gotham-Book.woff2',
      weight: '400',
      style: 'normal',
    },
  ],
});

const robotoFont = Roboto({
  weight: ['400', '700', '900'],
  style: ['normal'],
  subsets: ['latin'],
});

export { gothamFont, robotoFont };
